import { IncidentDetailsAnalysisSectionWebComponent } from './component/IncidentDetailsAnalysisSectionWebComponent';

export { IncidentDetailsAnalysisSectionWebComponent };
